module.exports = __webpack_public_path__ + "media/images/twitter-og-772428ce9da2a1d0d9e17498c011d941.png";